const Features = () => {
  const features = [
    {
      title: "Worldwide Leader",
      description: "GiveSendGo is trusted around the world for its simple, reliable fundraising platform.",
      icon: "https://static2.givesendgo.com/vue/freedomfundraising/worldwide-leader.png"
    },
    {
      title: "Simple Setup",
      description: "Personalize, share and start collecting money in just minutes.",
      icon: "https://static2.givesendgo.com/vue/freedomfundraising/simple-setup.png"
    },
    {
      title: "0% Platform Fee",
      description: "Keep more of the money you raised. We don't charge a platform fee.",
      icon: "https://static2.givesendgo.com/vue/freedomfundraising/zero-fee.png"
    },
    {
      title: "Share Hope",
      description: "Raise money to share hope. Money is temporary Jesus is eternal.",
      icon: "https://static2.givesendgo.com/vue/freedomfundraising/share-hope.png"
    },
    {
      title: "Easy Social Reach",
      description: "Share across multiple social platforms and mobile devices with just a couple clicks.",
      icon: "https://static2.givesendgo.com/vue/freedomfundraising/easy-social-reach.png"
    },
    {
      title: "A+ Customer Service",
      description: "Real people writing real responses. We are standing by, waiting to help.",
      icon: "https://static2.givesendgo.com/vue/freedomfundraising/customer-service.png"
    }
  ]

  return (
    <section className="relative flex flex-col items-center justify-center px-6 text-white freedom__section bg-slate-100 min-h-[600px] bg-fundraising-bg bg-cover bg-center">
      <div className="absolute inset-0 bg-gradient-to-r from-gsg-blue-dark/90 to-gsg-blue/90"></div>
      
      <div className="relative z-10 text-center max-w-6xl mx-auto py-16">
        <h1 id="freedom__heading" className="flex flex-col text-center mb-4">
          <span className="font-light text-3xl md:text-4xl mb-2">The Leader in</span>
          <span className="font-bold text-4xl md:text-5xl lg:text-6xl">Online Fundraising</span>
        </h1>
        
        <div className="w-40 h-1 bg-white mx-auto my-10 divider"></div>
        
        <div className="grid lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-8 mt-14">
          {features.map((feature, index) => (
            <div 
              key={feature.title} 
              className="flex flex-col items-center max-w-xs space-y-2 text-center animate-slide-up"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <img 
                className="w-24 h-24 mb-4 object-contain" 
                src={feature.icon} 
                alt={feature.title}
              />
              <h5 className="mt-4 text-xl font-semibold">{feature.title}</h5>
              <p className="text-gray-200">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Features